var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container_pop"},[_c('div',{staticClass:"close-view"},[_c('img',{attrs:{"src":require("../assets/ai/close.png"),"alt":"","srcset":""},on:{"click":function($event){return _vm.goBack()}}})]),_c('video',{attrs:{"src":_vm.videoPath,"playsinline":"","autoplay":"","loop":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }